import { render, staticRenderFns } from "./renew.vue?vue&type=template&id=57451954"
import script from "./renew.vue?vue&type=script&lang=js"
export * from "./renew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports